module.exports = __webpack_public_path__ + "img/gerch-project.71972021.jpg";